import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from '@spartacus/storefront';
import { CustomModalService } from './custom-modal.service';
import { CustomDomSanitaizer } from './dom-sanitizer.service';

@NgModule({
  providers: [
    {
      provide: ModalService,
      useExisting: CustomModalService,
    },
    {
      provide: DomSanitizer,
      useClass: CustomDomSanitaizer,
    },
  ],
})
export class SharedServicesModule {}
